import { render, staticRenderFns } from "./compareProperti.vue?vue&type=template&id=305a1028&"
import script from "./compareProperti.vue?vue&type=script&lang=ts&"
export * from "./compareProperti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports